import React, {Component} from 'react';
import './helpers_styles.css';

class CheckBoxCustomHelper extends Component{


    constructor(props) {
        super(props);
        this.state = {
            answer: []
        }
    }

    componentDidMount() {
        const {options, data} = this.props;

        if (data && options){
            if (typeof (data) === 'number'){
                this.setState({
                    answer: options.filter((el) => {
                        return el.id === data
                    })
                });
            } else {
                this.setState({
                    answer: this.answersArray(options, data)
                });
            }
        }
    }

    answersArray = (options, data) => {
        let arr = [];

        options.forEach(item => {
           if (data.includes(item.id)){
               arr.push(item)
           }
        });
        return arr;
    };


    render(){

        const answer = this.state.answer;
        let items = [];

        answer.forEach(item => {
            items.push(
                <span>{item.value}</span>
            )
        });

        return(
            <div className='checkbox-value'>
                {items}
            </div>
        )
    }
}

export default CheckBoxCustomHelper;


// WEBPACK FOOTER //
// ./src/helpers/CheckBoxCustomHelper.js